import React, { Component } from "react";
import { 
    Grid, 
    Row, 
    Col, 
    Button, 
    FormGroup,
    ControlLabel,
    FormControl 
} from "react-bootstrap";
import moment from "moment";
import { fetchAttendanceRuleRequest } from "../../../api/attendanceRule";
import { 
    formatAttendanceRuleCalculationType,
    formatAttendanceRuleType 
} from "../../../helpers/functions/attendanceRule";
class AttendanceRuleDetails extends Component {

    constructor(props) {
        super(props);
        this.state = {
            resource: {
                _id: '',
                type: '',
                label: '',
                description: '',
                standard: {},
                monday: {},
                tuesday: {},
                wednesday: {},
                thursday: {},
                friday: {},
                saturday: {},
                sunday: {},
                nightShiftConfig: {},
                overtimeConfig: {}
              },
        }
    }

    componentDidMount() {
        const { instanceId } = this.props;
        if(instanceId) {
            this.fetchAttendanceRule(instanceId)
        }
    }

    fetchAttendanceRule = (id) => {
        fetchAttendanceRuleRequest(id, result => this.setState({resource: result}), error => console.log(error))
    }

    render() {

        const { 
            _id, 
            type,
            label,
            description,
            standard,
            monday,
            tuesday,
            wednesday,
            thursday,
            friday,
            saturday,
            sunday,
            createdAt, 
            updatedAt,
            calculationType,
            nightShiftConfig,
            overtimeConfig
          } = this.state.resource;

        return (
            <Grid fluid>
                <div className="form-header">
                    <h3 className="text-secondary font-weight-bold">
                        Attendance Rule Instance Details
                    </h3>
                    <Button className="btn btn-primary top-btn" onClick={() => this.props.goToList('attendance-rule')}>Back to list</Button>
                </div>
                <Row>
                    <Col md={12}>
                        <div className="typo-line">
                            <div>
                            <p className="category">Instance ID</p>
                            {_id || 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Type</p>
                            {formatAttendanceRuleType(type) || 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Calculation Type</p>
                            {formatAttendanceRuleCalculationType(calculationType) || 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Name</p>
                            {label || 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Description</p>
                            {description || 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Created At</p>
                            {createdAt ? moment(createdAt).format('MMMM Do YYYY, h:mm:ss a') : 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Updated At</p>
                            {updatedAt ? moment(updatedAt).format('MMMM Do YYYY, h:mm:ss a') : 'N/A'}
                            </div>
                        </div>
                        {calculationType === 'addPerMinute' &&
                            <div className="form-section-wrapper">
                                <h3 className="title" style={{marginBottom: 10}}>Parameter</h3>
                                <Row
                                    className="form-section"
                                >
                                    <div className="col-md-12">
                                        <FormGroup>
                                            <ControlLabel>Percentage</ControlLabel>
                                            <FormControl
                                                type="text"
                                                name="percentage"
                                                value={type === "nightShift" ? nightShiftConfig.percentage : overtimeConfig.percentage}
                                                readOnly
                                                placeholder=""
                                            />
                                        </FormGroup>
                                    </div>
                                </Row>
                                <Row
                                    className="form-section"
                                >
                                    <div className="col-md-12">
                                        <FormGroup>
                                            <ControlLabel>Start Time</ControlLabel>
                                            <FormControl
                                                type="text"
                                                name="startTime"
                                                value={type === "nightShift" ? nightShiftConfig.startTime : overtimeConfig.startTime}
                                                readOnly
                                                placeholder=""
                                            />
                                        </FormGroup>
                                    </div>
                                </Row>
                                <Row
                                    className="form-section"
                                >
                                    <div className="col-md-12">
                                        <FormGroup>
                                            <ControlLabel>End Time</ControlLabel>
                                            <FormControl
                                                type="text"
                                                name="endTime"
                                                value={type === "nightShift" ? nightShiftConfig.endTime : overtimeConfig.endTime}
                                                readOnly
                                                placeholder=""
                                            />
                                        </FormGroup>
                                    </div>
                                </Row>
                            </div>
                        }
                        {calculationType === 'multiplicator' &&
                            <div className="form-section-wrapper">
                                <h3 className="title" style={{marginBottom: 10}}>Multiplicator</h3>
                                <Row
                                    className="form-section"
                                >
                                    <div className="col-md-12">
                                        <h6>
                                            Standard
                                        </h6>
                                    </div>
                                    <div className="col-md-3">
                                        <FormGroup>
                                        <ControlLabel>Whole Day</ControlLabel>
                                        <FormControl
                                            type="text"
                                            name="wholeDay"
                                            value={standard.wholeDay}
                                            readOnly
                                            placeholder=""
                                        />
                                        </FormGroup>
                                    </div>
                                    <div className="col-md-3">
                                        <FormGroup>
                                        <ControlLabel>Half Day AM</ControlLabel>
                                        <FormControl
                                            type="text"
                                            name="halfDayAm"
                                            value={standard.halfDayAm}
                                            readOnly
                                            placeholder=""
                                        />
                                        </FormGroup>
                                    </div>
                                    <div className="col-md-3">
                                        <FormGroup>
                                        <ControlLabel>Half Day PM</ControlLabel>
                                        <FormControl
                                            type="text"
                                            name="halfDayPm"
                                            value={standard.halfDayPm}
                                            readOnly
                                            placeholder=""
                                        />
                                        </FormGroup>
                                    </div>
                                </Row>
                                <Row
                                    className="form-section"
                                >
                                    <div className="col-md-12">
                                        <h6>
                                            Monday
                                        </h6>
                                    </div>
                                    <div className="col-md-3">
                                        <FormGroup>
                                        <ControlLabel>Whole Day</ControlLabel>
                                        <FormControl
                                            type="text"
                                            name="wholeDay"
                                            value={monday.wholeDay}
                                            readOnly
                                            placeholder=""
                                        />
                                        </FormGroup>
                                    </div>
                                    <div className="col-md-3">
                                        <FormGroup>
                                        <ControlLabel>Half Day AM</ControlLabel>
                                        <FormControl
                                            type="text"
                                            name="halfDayAm"
                                            value={monday.halfDayAm}
                                            readOnly
                                            placeholder=""
                                        />
                                        </FormGroup>
                                    </div>
                                    <div className="col-md-3">
                                        <FormGroup>
                                        <ControlLabel>Half Day PM</ControlLabel>
                                        <FormControl
                                            type="text"
                                            name="halfDayPm"
                                            value={monday.halfDayPm}
                                            readOnly
                                            placeholder=""
                                        />
                                        </FormGroup>
                                    </div>
                                </Row>
                                <Row
                                    className="form-section"
                                >
                                    <div className="col-md-12">
                                        <h6>
                                            Tuesday
                                        </h6>
                                    </div>
                                    <div className="col-md-3">
                                        <FormGroup>
                                        <ControlLabel>Whole Day</ControlLabel>
                                        <FormControl
                                            type="text"
                                            name="wholeDay"
                                            value={tuesday.wholeDay}
                                            readOnly
                                            placeholder=""
                                        />
                                        </FormGroup>
                                    </div>
                                    <div className="col-md-3">
                                        <FormGroup>
                                        <ControlLabel>Half Day AM</ControlLabel>
                                        <FormControl
                                            type="text"
                                            name="halfDayAm"
                                            value={tuesday.halfDayAm}
                                            readOnly
                                            placeholder=""
                                        />
                                        </FormGroup>
                                    </div>
                                    <div className="col-md-3">
                                        <FormGroup>
                                        <ControlLabel>Half Day PM</ControlLabel>
                                        <FormControl
                                            type="text"
                                            name="halfDayPm"
                                            value={tuesday.halfDayPm}
                                            readOnly
                                            placeholder=""
                                        />
                                        </FormGroup>
                                    </div>
                                </Row>
                                <Row
                                    className="form-section"
                                >
                                    <div className="col-md-12">
                                        <h6>
                                            Wednesday
                                        </h6>
                                    </div>
                                    <div className="col-md-3">
                                        <FormGroup>
                                        <ControlLabel>Whole Day</ControlLabel>
                                        <FormControl
                                            type="text"
                                            name="wholeDay"
                                            value={wednesday.wholeDay}
                                            readOnly
                                            placeholder=""
                                        />
                                        </FormGroup>
                                    </div>
                                    <div className="col-md-3">
                                        <FormGroup>
                                        <ControlLabel>Half Day AM</ControlLabel>
                                        <FormControl
                                            type="text"
                                            name="halfDayAm"
                                            value={wednesday.halfDayAm}
                                            readOnly
                                            placeholder=""
                                        />
                                        </FormGroup>
                                    </div>
                                    <div className="col-md-3">
                                        <FormGroup>
                                        <ControlLabel>Half Day PM</ControlLabel>
                                        <FormControl
                                            type="text"
                                            name="halfDayPm"
                                            value={wednesday.halfDayPm}
                                            readOnly
                                            placeholder=""
                                        />
                                        </FormGroup>
                                    </div>
                                </Row>
                                <Row
                                    className="form-section"
                                >
                                    <div className="col-md-12">
                                        <h6>
                                            Thursday
                                        </h6>
                                    </div>
                                    <div className="col-md-3">
                                        <FormGroup>
                                        <ControlLabel>Whole Day</ControlLabel>
                                        <FormControl
                                            type="text"
                                            name="wholeDay"
                                            value={thursday.wholeDay}
                                            readOnly
                                            placeholder=""
                                        />
                                        </FormGroup>
                                    </div>
                                    <div className="col-md-3">
                                        <FormGroup>
                                        <ControlLabel>Half Day AM</ControlLabel>
                                        <FormControl
                                            type="text"
                                            name="halfDayAm"
                                            value={thursday.halfDayAm}
                                            readOnly
                                            placeholder=""
                                        />
                                        </FormGroup>
                                    </div>
                                    <div className="col-md-3">
                                        <FormGroup>
                                        <ControlLabel>Half Day PM</ControlLabel>
                                        <FormControl
                                            type="text"
                                            name="halfDayPm"
                                            value={thursday.halfDayPm}
                                            readOnly
                                            placeholder=""
                                        />
                                        </FormGroup>
                                    </div>
                                </Row>
                                <Row
                                    className="form-section"
                                >
                                    <div className="col-md-12">
                                        <h6>
                                            Friday
                                        </h6>
                                    </div>
                                    <div className="col-md-3">
                                        <FormGroup>
                                        <ControlLabel>Whole Day</ControlLabel>
                                        <FormControl
                                            type="text"
                                            name="wholeDay"
                                            value={friday.wholeDay}
                                            readOnly
                                            placeholder=""
                                        />
                                        </FormGroup>
                                    </div>
                                    <div className="col-md-3">
                                        <FormGroup>
                                        <ControlLabel>Half Day AM</ControlLabel>
                                        <FormControl
                                            type="text"
                                            name="halfDayAm"
                                            value={friday.halfDayAm}
                                            readOnly
                                            placeholder=""
                                        />
                                        </FormGroup>
                                    </div>
                                    <div className="col-md-3">
                                        <FormGroup>
                                        <ControlLabel>Half Day PM</ControlLabel>
                                        <FormControl
                                            type="text"
                                            name="halfDayPm"
                                            value={friday.halfDayPm}
                                            readOnly
                                            placeholder=""
                                        />
                                        </FormGroup>
                                    </div>
                                </Row>
                                <Row
                                    className="form-section"
                                >
                                    <div className="col-md-12">
                                        <h6>
                                            Saturday
                                        </h6>
                                    </div>
                                    <div className="col-md-3">
                                        <FormGroup>
                                        <ControlLabel>Whole Day</ControlLabel>
                                        <FormControl
                                            type="text"
                                            name="wholeDay"
                                            value={saturday.wholeDay}
                                            readOnly
                                            placeholder=""
                                        />
                                        </FormGroup>
                                    </div>
                                    <div className="col-md-3">
                                        <FormGroup>
                                        <ControlLabel>Half Day AM</ControlLabel>
                                        <FormControl
                                            type="text"
                                            name="halfDayAm"
                                            value={saturday.halfDayAm}
                                            readOnly
                                            placeholder=""
                                        />
                                        </FormGroup>
                                    </div>
                                    <div className="col-md-3">
                                        <FormGroup>
                                        <ControlLabel>Half Day PM</ControlLabel>
                                        <FormControl
                                            type="text"
                                            name="halfDayPm"
                                            value={saturday.halfDayPm}
                                            readOnly
                                            placeholder=""
                                        />
                                        </FormGroup>
                                    </div>
                                </Row>
                                <Row
                                    className="form-section"
                                >
                                    <div className="col-md-12">
                                        <h6>
                                            Sunday
                                        </h6>
                                    </div>
                                    <div className="col-md-3">
                                        <FormGroup>
                                        <ControlLabel>Whole Day</ControlLabel>
                                        <FormControl
                                            type="text"
                                            name="wholeDay"
                                            value={sunday.wholeDay}
                                            readOnly
                                            placeholder=""
                                        />
                                        </FormGroup>
                                    </div>
                                    <div className="col-md-3">
                                        <FormGroup>
                                        <ControlLabel>Half Day AM</ControlLabel>
                                        <FormControl
                                            type="text"
                                            name="halfDayAm"
                                            value={sunday.halfDayAm}
                                            readOnly
                                            placeholder=""
                                        />
                                        </FormGroup>
                                    </div>
                                    <div className="col-md-3">
                                        <FormGroup>
                                        <ControlLabel>Half Day PM</ControlLabel>
                                        <FormControl
                                            type="text"
                                            name="halfDayPm"
                                            value={sunday.halfDayPm}
                                            readOnly
                                            placeholder=""
                                        />
                                        </FormGroup>
                                    </div>
                                </Row>                            
                            </div>
                        }
                        <Button className="btn btn-primary bottom-btn" onClick={() => this.props.goToEditForm('attendance-rule', _id)}>Edit</Button>
                    </Col>
                </Row>
            </Grid>
        );
    }
}

export default AttendanceRuleDetails;
